<template>
    <div>
        <span>{{ prompt }}</span>
        <iframe frameborder="0" :id="`${frameId}-file-frame`"
                :src="fileString"
                :height="frameHeight"
                :width="frameWidth"
        ></iframe>
    </div>
</template>

<script>
export default {
    name: "CmsFileFrame",

    props: {

        fileString: {
            type: String,
            default() {
                return '';
            }
        },

        prompt: {
            type: String,
            default() {
                return '';
            }
        },

        frameHeight: {
            type: Number,
            default() {
                return 500;
            }
        },

        frameWidth: {
            type: Number,
            default() {
                return 720;
            }
        },

        frameId: {
            type: String,
            default() {
                return '';
            }
        }

    }
}
</script>

<style scoped>

</style>